import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const COURSES = buildModuleApi({
    prefix: "COURSES",
    uri: "courses",
    withExtra: false,
    exclude: ["ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE", "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM"],
    overrides: {
        LIST: { url: "/courses" }, CREATE: { url: "/courses" }, UPDATE: { url: "/courses" }, REMOVE: { url: "/courses" }, DETAIL: { url: "/courses/:id" },
    },
    extraActions: {
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
        MODULE_CREATE: { suffix: "/:courseId/modules" }, MODULE_UPDATE: { suffix: "/modules" }, MODULE_REMOVE: { suffix: "/modules" },
        MODULE_ARCHIVE_LIST: { suffix: "/modules/archived/list" }, MODULE_ARCHIVE: { suffix: "/modules/:id/archive" }, MODULE_RESTORE: { suffix: "/modules/:id/restore" },
        LESSON_CREATE: { suffix: "/:courseId/lessons" }, LESSON_UPDATE: { suffix: "/lessons" }, LESSON_REMOVE: { suffix: "/lessons" },
        LESSON_ARCHIVE_LIST: { suffix: "/lessons/archived/list" }, LESSON_ARCHIVE: { suffix: "/lessons/:id/archive" }, LESSON_RESTORE: { suffix: "/lessons/:id/restore" },
        TASK_CREATE: { suffix: "/:courseId/tasks" }, TASK_UPDATE: { suffix: "/tasks" }, TASK_REMOVE: { suffix: "/tasks" },
        TASK_ARCHIVE_LIST: { suffix: "/tasks/archived/list" }, TASK_ARCHIVE: { suffix: "/tasks/:id/archive" }, TASK_RESTORE: { suffix: "/tasks/:id/restore" },
        SCHEDULE_CREATE: { suffix: "/:courseId/schedule" }, SCHEDULE_UPDATE: { suffix: "/schedule" }, SCHEDULE_REMOVE: { suffix: "/schedule" },
        SCHEDULE_ARCHIVE_LIST: { suffix: "/schedule/archived/list" }, SCHEDULE_ARCHIVE: { suffix: "/schedule/:id/archive" }, SCHEDULE_RESTORE: { suffix: "/schedule/:id/restore" },
    },
});

export const COURSES_API = COURSES.API;
export const COURSES_CONSTANTS = COURSES.CONSTANTS;
export const COURSES_ENDPOINTS = COURSES.ENDPOINTS;
